import React from "react";
import { BrowserRouter as Router, Routes, Route, useParams } from "react-router-dom";

import Navbar from "./components/layout/Navbar";
import AppFooter from "./components/layout/AppFooter";
import User from "./components/users/User";
import RepoDetail from "./components/pages/RepoDetail";
import AlertReducer from "./components/layout/AlertReducer";
import About from "./components/pages/About";
import Home from "./components/pages/Home";
import NotFound from "./components/pages/NotFound";
import GuideIndex from "./components/pages/guides/GuideIndex";
import GuideFindDevelopers from "./components/pages/guides/GuideFindDevelopers";
import GuideSearchRepositories from "./components/pages/guides/GuideSearchRepositories";
import GuideFaqPage from "./components/pages/guides/GuideFaqPage";
import FeaturedDevelopersPage from "./components/pages/FeaturedDevelopersPage";
import RateLimitsPage from "./components/pages/RateLimitsPage";
import { Analytics } from "@vercel/analytics/react";
import "./App.css";

import GithubState from "./context/github/GithubState";
import AlertState from "./context/alert/alertState";
import { ThemeProvider } from "./context/ThemeContext";

const UserPage = () => {
  const { login } = useParams();
  return <User key={login} />;
};

const App = () => {
  return (
    <ThemeProvider>
      <GithubState>
        <AlertState>
          <Router>
            <div className="App gf-app">
              <Analytics />
              <Navbar />
              <div className="gf-main-wrap">
                <AlertReducer />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/featured-developers" element={<FeaturedDevelopersPage />} />
                  <Route path="/system/rate-limits" element={<RateLimitsPage />} />
                  <Route path="/guide" element={<GuideIndex />} />
                  <Route path="/guide/find-github-developers" element={<GuideFindDevelopers />} />
                  <Route path="/guide/search-github-repositories" element={<GuideSearchRepositories />} />
                  <Route path="/guide/faq" element={<GuideFaqPage />} />
                  <Route path="/user/:login" element={<UserPage />} />
                  <Route path="/repo/:owner/:name" element={<RepoDetail />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
                <AppFooter />
              </div>
            </div>
          </Router>
        </AlertState>
      </GithubState>
    </ThemeProvider>
  );
};

export default App;
